var map = {
	"./icons_big_excessmort.svg": 68,
	"./icons_big_gdp.svg": 69,
	"./icons_big_icu.svg": 70,
	"./icons_big_kof.svg": 71,
	"./icons_big_positivity.svg": 72,
	"./icons_big_schools.svg": 73,
	"./icons_big_sequenced.svg": 74,
	"./icons_big_tests.svg": 75,
	"./icons_big_unemploy.svg": 76,
	"./icons_big_vaccdays.svg": 77
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;